import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import validations from '../../../../helpers/Validations';

import HtmlInput from '../../../../interfaces/HtmlInput';
import ServiceRegistration from '../../../../services/RegisterService';

import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import Alert, { AlertVariant } from '../../../../components/Alert';

import useGTMEventsTracker from '../../../../hooks/useGTMEventsTracker';
import {
  gtmAttributesUpdateForgotPasswordPage,
  gtmAttributesInvalidEmail,
} from '../../../../utils/gtmVariables';
import Typography from '../../../../components/Typography';

interface Props {
  next: Function;
}

const EmailStep = ({ next }: Props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [valid, setValid] = useState(false);
  const [show, setShow] = useState(false);
  const [variant, setVariant] = useState<AlertVariant | undefined>(undefined);
  const [message, setMessage] = useState(<></>);
  const [disableButton, setDisableButton] = useState(false);

  const serviceRegistration = new ServiceRegistration();
  const gtmEventsTracker = useGTMEventsTracker();

  gtmEventsTracker(gtmAttributesUpdateForgotPasswordPage);

  const change = () => {
    setDisableButton(true);
    if (email && email !== '' && valid) {
      serviceRegistration
        .recoverPassword(email)
        .then(() => {
          return next(2);
        })
        .catch((error) => {
          setVariant('warning');
          gtmEventsTracker(gtmAttributesInvalidEmail);
          setDisableButton(false);
          const errorMessage = error.response.data.motivos
            ? error.response.data.motivos[0]
            : 'Erro desconhecido';
          if (errorMessage === 'Erro desconhecido') {
            setMessage(
              <>
                Email incorreto. <strong> Por favor, tente novamente!</strong>
              </>
            );
          } else {
            setMessage(<>{errorMessage}</>);
          }
          setShow(true);
          setTimeout(() => {
            setShow(false);
          }, 3000);
        });
    }
  };
  const changeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target) {
      const email = validations.toLowerCase(e);
      setEmail(email);
      setValid(true);
    } else {
      setValid(false);
    }
  };

  return (
    <div className="mx-auto flex flex-col items-center px-5 py-12" id="mp__recovar-password">
      <Typography as="span" variant="title1" className="text-center mb-2">
        Recuperação de senha
      </Typography>
      <Typography as="p" variant="body2" className="text-center mb-12">
        Por favor, digite seu e-mail para redefinição de senha:
      </Typography>
      <div className="mb-6 w-full md:max-w-[470px]">
        <Input
          id="mp__input-email_mail"
          label="Email"
          type="email"
          name="email"
          value={email}
          rules={[(val: HtmlInput) => validations.isValidEmail(val, true)]}
          onChange={(e: any) => changeEmail(e)}
        />
      </div>
      <div className="flex flex-col md:flex-row-reverse w-full md:max-w-[470px] mt-6 mb-28 gap-3">
        <Button
          id="mp__btn-email_redefine"
          text="Redefinir senha"
          type="submit"
          variant="primary"
          classNames="rounded-lg w-full"
          onClick={change}
          disabled={disableButton}
        />
        <Button
          id="mp__btn-email_back"
          text="Voltar"
          type="reset"
          variant="secondary"
          classNames="rounded-lg w-full"
          onClick={() => navigate('/login')}
        />
      </div>
      <div className="absolute top-[3.688rem] right-[5.5rem] w-[23.625rem] max-[640px]:left-0 max-[640px]:right-0 max-[640px]:top-1">
        <Alert
          show={show}
          variant={variant}
          onClose={() => setShow(false)}
          dismissible
          closeVariant="white"
        >
          <Typography>{message}</Typography>
        </Alert>
      </div>
    </div>
  );
};

export default EmailStep;
